import { createSelector } from "@reduxjs/toolkit";
import { selectHttpSingleRoomFull } from "../Room/httpRoomSelectors";
import { selectActiveCeilingHeightAboveFloorMm } from "../McBim/mcbimSelectors";
type IRoomPropertyRow = {
  property: string;
  value: string;
  source?: string;
};

export const selectRoomInfoRows = createSelector(
  [selectHttpSingleRoomFull, selectActiveCeilingHeightAboveFloorMm],
  (room, activeCeilingHeightAboveFloorMm): IRoomPropertyRow[] => {
    if (room == null) return [];
    const data: IRoomPropertyRow[] = [];

    const addRow = (property: string, value: unknown, source?: string) => {
      if (value === undefined || value === null || value === "") return;

      let v: string;
      if (typeof value === "string") v = value;
      else if (typeof value === "number") v = value.toString();
      else if (value instanceof Date) v = value.toISOString();
      else v = JSON.stringify(value);

      data.push({ property, value: v, source });
    };

    addRow("Nummer", room.roomNumber, "IFC");
    addRow("Navn", room.roomName, "IFC");
    addRow("Tilluft", room.supplyAirFlow, "Excel");
    addRow("Avtrekk", room.returnAirFlow, "Excel");
    addRow("Standardrom", room.rfpMalRom, "dRofus");
    addRow("dRofus-status", room.rfpStatus, "dRofus");
    addRow("PNS", room.extraIfcInfo?.pns, "IFC");
    addRow(
      "Himling over gulv",
      activeCeilingHeightAboveFloorMm == null ? undefined : `${activeCeilingHeightAboveFloorMm} mm`,
      "MCBIM"
    );

    // 👇 Ny rad: ML-predikerte devices (antall)
    if (Array.isArray(room.mlPredictedDevices)) {
      addRow("ML-predikerte devices", room.mlPredictedDevices.length, "ML-tjeneste");
    }

    addRow("Oppdatert", room.updatedAt, "MCApps");
    if (room.multiplacerCeilingDevicesLocked) {
      addRow("Låst", room.multiplacerCeilingDevicesLocked.bool ? "Ja" : "Nei", "MCApps");
      addRow("Låst dato", room.multiplacerCeilingDevicesLocked.lockedAt, "MCApps");
    }

    return data;
  }
);
const groups = [
  {
    title: "Ventilasjon og himling",
    metrics: true,
    keys: ["Tilluft", "Avtrekk", "Himling over gulv"],
  },
  {
    title: "Rom og klassifisering",
    metrics: false,
    keys: ["Nummer", "Navn", "Standardrom", "dRofus-status", "PNS"],
  },
  {
    title: "Data og oppdatering",
    metrics: false,
    keys: ["ML-predikerte devices", "Oppdatert", "Låst", "Låst dato"],
  },
];
const dateFormatter = new Intl.DateTimeFormat("nb-NO", { dateStyle: "medium", timeStyle: "short" });
export const selectRoomInfoGroups = createSelector([selectRoomInfoRows], (rows) =>
  groups
    .map((group) => ({
      ...group,
      entries: rows
        .filter((row) => group.keys.includes(row.property))
        .map((row) => {
          const date = ["Oppdatert", "Låst dato"].includes(row.property)
            ? new Date(row.value)
            : null;
          return {
            ...row,
            displayValue:
              date && !Number.isNaN(date.getTime()) ? dateFormatter.format(date) : row.value,
          };
        }),
    }))
    .filter((group) => group.entries.length)
);
export const selectRoomInfoJson = createSelector([selectHttpSingleRoomFull], (room) =>
  JSON.stringify(room, null, 2)
);
